import { createFileRoute } from '@tanstack/react-router';

import { getAccountReceivableQueryOptions } from '@/_pages/account-receivables/api-service';
import Loading from '@/_pages/account-receivables/profile/loading';

export const Route = createFileRoute('/_private/account-receivables/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAccountReceivableQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
